import React from 'react';
import { useMemo } from 'react';
import IntroMessage from '../IntroMessage';
import WelcomeMessage from '../WelcomeMessage';
import WarningMessage from '../WarningMessage';
import useTracking from './useTracking';

const useChatFlowLogic = ({
  initializeChat,
  resumeChat,
  sendMessage,
  retrieveOrCreateThread,
  disableChat,
  threadRef,
  usageCounter,
  showSofabuddySurvey,
  currentProfileId,
  sofabuddyCookieExists,
  sofabuddySurveyClicked,
  t
}) => {
  const { amplitudeTracking } = useTracking();

  const flow = useMemo(
    () => ({
      start: {
        component: () => initializeChat()
      },
      intro: {
        message: params => {
          params.injectMessage(
            <IntroMessage startChat={() => resumeChat()} />,
            'system'
          );
        }
      },
      welcome: {
        message: params => {
          params.injectMessage(
            <WelcomeMessage
              showSofabuddySurvey={showSofabuddySurvey}
              currentProfileId={currentProfileId}
              sofabuddyCookieExists={sofabuddyCookieExists}
              sofabuddySurveyClicked={sofabuddySurveyClicked}
            />
          );
        },
        path: 'loop'
      },
      loop: {
        message: async params => {
          if (!threadRef.current) {
            const createdThread = await retrieveOrCreateThread(params);
            if (createdThread) {
              threadRef.current = createdThread;
              await sendMessage(params, createdThread);
            }
          } else {
            await sendMessage(params, threadRef.current);
          }
        },
        path: () => 'loop'
      },
      end: {
        message: params => {
          params.injectMessage(
            <WarningMessage
              message={t('sofabuddy_chat_bot.warning_messages.usage_limit')}
            />,
            'warning'
          );
          amplitudeTracking('sofabuddy_chat_disabled');
        },
        chatDisabled: true
      }
    }),
    [
      initializeChat,
      resumeChat,
      sendMessage,
      retrieveOrCreateThread,
      disableChat,
      threadRef,
      usageCounter,
      showSofabuddySurvey,
      currentProfileId,
      sofabuddyCookieExists,
      sofabuddySurveyClicked,
      t,
      amplitudeTracking
    ]
  );

  return flow;
};

export default useChatFlowLogic;
